import {
  Operations,
  Timeslot,
  TimeslotType,
} from "../../bookmydesk-api-sdk-typescript-axios";

export const kTimeslots: (Timeslot & Operations)[] = [
  {
    id: "068db54d-52a7-43ea-b16d-e0b2aa251a9a",
    name: "All day",
    from: "08:00",
    to: "18:00",
    type: "desk" as TimeslotType,
    _operations: {
      canDelete: true,
    },
  },
];
